import styled from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

export const NumberLabel = styled.div<IWithSize>`
  background-color: #ffffff;
  min-width: ${({ size }) => (size ? 64 * size : 64)}px;
  word-break: break-all;
  padding: ${({ size }) => (size ? 3 * size : 3)}px;
  border-radius: 3px;
  color: #000000;
  text-align: center;
  font-weight: 500;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
`
